import React, {memo} from "react";
import Typography from "@material-ui/core/Typography";
import TableContainer from '@material-ui/core/TableContainer';
import { MDXProvider } from "@mdx-js/react";
import FrameworkPanel from "./framework_panel";
import idToContent from "../data/id_to_content_mapping";

const DefinitionContainer = (props) => {
  const {definitions, components} = props;

  return (
    <div>
      <MDXProvider components={components}>
        {definitions}
      </MDXProvider>
    </div>
  );
};

const RubricContainer = (props) => {
  const {rubric, components} = props;

  return (
    <div>
      <TableContainer>
        <MDXProvider components={components}>
          {rubric}
        </MDXProvider>
      </TableContainer>
    </div>
  );
};

const GraphContainer = (props) => {
  const {results} = props;

  return (
    <div>
      {results.map((result) => (
        <div>
          <Typography variant={"h6"} component={"h6"} style={{margin: "30px 0px 20px 0px", fontSize: "110%"}}>
            {result.title}
          </Typography>
          <div>
            <div style={{padding: "9px 0px 25px 0px"}}>
              <Typography variant={"body1"} component={"p"}>
                {result.description}
              </Typography>
            </div>
            <div style={{textAlign: "center"}}>
              {result.graphs.map((graph_meta) => (
                <div style={{display: "inline-block", textAlign: "center", width: "50%", minWidth: "320px",
                              verticalAlign: "top"}}>
                  <div>{graph_meta.graph}</div>
                  <div style={{padding: "10px 0px", fontSize: "85%"}}>{graph_meta.description}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const Framework = (props) => {
  const {frameworkId} = props;

  const components = {
      p: (() => {
        return memo(props =>
          <Typography {...props} component="p" variant="body1" style={{marginBottom: "20px"}}/>);
      })(),
      h5: (() => {
        return memo(props =>
          <div style={{textAlign: "center"}}>
            <Typography {...props} component="h5" variant="h5" style={{margin: "20px 0px 10px 0px"}}/>
          </div>
        );
      })(),
      h6: (() => {
        return memo(props =>
          <Typography {...props} component="h6" variant="h6" style={{margin: "30px 0px 20px 0px"}}/>);
      })()
  };

  const tabs = [
    {
      "label": "Definitions",
      "content": <DefinitionContainer components={components} definitions={idToContent[frameworkId]["definitions"]}/>
    }
  ];
  if("rubric" in idToContent[frameworkId]){
    tabs.push({
      "label": "Rubric",
      "content": <RubricContainer components={components} rubric={idToContent[frameworkId]["rubric"]}/>
    })
  }
  if("results" in idToContent[frameworkId]){
    tabs.push({
      "label": "Results",
      "content": <GraphContainer results={idToContent[frameworkId]["results"]}/>
    })
  }

  return (
    <div style={{margin: "auto", maxWidth: "1300px", paddingBottom: "80px"}}>
      <FrameworkPanel tabs={tabs} title={"Framework "+frameworkId} isSubFramework={true}/>
    </div>
  );
};

export default Framework;